import React from 'react';
import { TDR } from 'tdr-common';
import { TableDrawerTags } from '../table-drawer/TableDrawerTags';

type TableInfoProps = {
	name: string;
	table: TDR.Table;
	priceElement?: React.ReactNode;
}

export const CarouselCardInfo = ({ name, table, priceElement }: TableInfoProps) => {
	return (
		<div className="w-full pt-2 pb-4">
			<div className="flex justify-between px-3 text-xl mb-1">
				<p className="font-lora">{name}</p>
				{priceElement}
			</div>
			<div className="px-2">
				<TableDrawerTags table={table} />
			</div>
		</div>
	);
};
